import type { ResearchIconName } from "@/lib/icons/research-icons";
import type { LandingTextValue } from "@/lib/landing/puck/styled-text";
import {
  COMPANY_ADDRESS,
  COMPANY_EMAIL,
  COMPANY_LEGAL_NAME,
  COMPANY_PHONE_DISPLAY,
  COMPANY_PHONE_E164,
  COMPANY_REQUISITES_URL,
  COMPANY_SITE_URL,
  COMPANY_YANDEX_MAP_URL,
} from "@/lib/brand/organization";
import { BRAND_NAME } from "@/lib/brand";

export type LandingLinkListItemKind = "link" | "text";

export type LandingLinkListItem = {
  kind?: LandingLinkListItemKind;
  label: LandingTextValue;
  href?: string;
  external?: boolean;
  icon?: ResearchIconName;
};

export const DEFAULT_LEGAL_DOCUMENT_LINKS: LandingLinkListItem[] = [
  { kind: "link", label: "Договор-оферта", href: "/legal/offer", icon: "receipt" },
  {
    kind: "link",
    label: "Согласие на обработку персональных данных",
    href: "/legal/privacy",
    icon: "shieldCheck",
  },
  { kind: "link", label: "Политика Cookies", href: "/legal/cookies", icon: "fileText" },
];

export const DEFAULT_LINK_LIST = {
  sectionId: "link-list",
  title: "Документы",
  lead: "",
  items: DEFAULT_LEGAL_DOCUMENT_LINKS,
};

export const DEFAULT_CONTACTS_LOCATION_ITEMS: LandingLinkListItem[] = [
  {
    kind: "text",
    label: COMPANY_ADDRESS.formatted,
    icon: "mapPin",
  },
  {
    kind: "link",
    label: "Открыть в Яндекс.Картах",
    href: COMPANY_YANDEX_MAP_URL,
    icon: "mapPin",
    external: true,
  },
];

export const DEFAULT_CONTACTS_NAP_ITEMS: LandingLinkListItem[] = [
  {
    kind: "link",
    label: COMPANY_PHONE_DISPLAY,
    href: `tel:${COMPANY_PHONE_E164}`,
    icon: "phone",
  },
  {
    kind: "link",
    label: COMPANY_EMAIL,
    href: `mailto:${COMPANY_EMAIL}`,
    icon: "mail",
  },
  {
    kind: "link",
    label: "smartbiznes.org",
    href: COMPANY_SITE_URL,
    icon: "link",
    external: true,
  },
];

export const DEFAULT_CONTACTS_LEGAL_ITEMS: LandingLinkListItem[] = [
  {
    kind: "text",
    label: `${COMPANY_LEGAL_NAME}. Реквизиты доступны для просмотра и скачивания по ссылке ниже.`,
    icon: "building",
  },
  {
    kind: "link",
    label: "Реквизиты ООО",
    href: COMPANY_REQUISITES_URL,
    icon: "fileText",
    external: true,
  },
];

export function defaultContactsDocumentsTitle(): string {
  return `Документы сервиса ${BRAND_NAME}`;
}
